module.exports = __webpack_public_path__ + "static/media/19.3fa1eaa4.webp";